import { Crown, Medal } from 'lucide-react';

export interface RankBadgeProps {
  readonly rank: number;
  readonly size?: 'sm' | 'md' | 'lg';
  readonly className?: string;
}

const SIZE_CLASS: Record<NonNullable<RankBadgeProps['size']>, string> = {
  sm: 'h-6 w-6 text-xs',
  md: 'h-8 w-8 text-sm',
  lg: 'h-12 w-12 text-base',
};

const RANK_RING: Record<number, string> = {
  1: 'ring-rank-1',
  2: 'ring-rank-2',
  3: 'ring-rank-3',
};

export function RankBadge({ rank, size = 'md', className = '' }: RankBadgeProps) {
  const isPodium = rank >= 1 && rank <= 3;
  const Icon = rank === 1 ? Crown : Medal;
  const ring = isPodium ? RANK_RING[rank] : 'ring-border';
  const text = isPodium ? 'text-fg' : 'text-fg-muted';
  return (
    <span
      data-testid={`rank-badge-${rank}`}
      data-appdom-id={`rank-badge-${rank}`}
      data-appdom-type="Badge"
      data-appdom-label={`Rank ${rank}`}
      aria-label={`Rank ${rank}`}
      className={`inline-flex items-center justify-center rounded-full bg-surface-raised ring-2 ${ring} ${SIZE_CLASS[size]} ${text} ${className}`}
    >
      {isPodium ? <Icon className="h-4 w-4" aria-hidden /> : rank}
    </span>
  );
}
